import type { MouseEvent, ReactElement } from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { TOGGLE_GROUP_SX } from "./ToolboxButtons.constants";

interface ToolboxButtonsProps {
  buttons: ReactElement<any>[];
  selected: string;
  onChange: (selected: string) => void;
}

const ToolboxButtons = ({ buttons, selected, onChange }: ToolboxButtonsProps) => {
  const handleChange = (_e: MouseEvent<HTMLElement>, newSelected: string) => {
    const selectedButtonProps = buttons.find(
      (button) => button.props.value === newSelected
    )?.props;

    if (!selectedButtonProps?.disabled) onChange(newSelected);
  };

  return (
    <ToggleButtonGroup
      orientation="vertical"
      value={selected}
      exclusive
      onChange={handleChange}
      sx={TOGGLE_GROUP_SX}
      data-test-id="toolbox-buttons"
    >
      {buttons.map((child) => {
        const { icon: Icon, tooltip, disabled } = child.props;

        return (
          <Tooltip
            key={child.props.value}
            arrow
            placement="left"
            disableInteractive
            title={selected !== child.props.value ? tooltip : undefined}
          >
            <ToggleButton
              value={child.props.value}
              aria-label="toolbox button"
              sx={{
                ...(disabled && {
                  opacity: 0.35,
                  cursor: "default",
                  color: "inherit !important",

                  "&:hover": {
                    color: "inherit !important",
                  },
                }),
              }}
            >
              <Icon />
            </ToggleButton>
          </Tooltip>
        );
      })}
    </ToggleButtonGroup>
  );
};

export default ToolboxButtons;
